<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
/* Global styles here */

</style>
